<template>
  <div class="advice">
    <div class="left">
      <div v-loading="configLoading" class="advice-card">
        <div class="advice-card__header" @click="cardExpanded = !cardExpanded">
          <div class="advice-card__icon">
            <i class="icon-flag-line t-iconfont"></i>
          </div>
          <div class="advice-card__info">
            <div class="advice-card__title">行动策略</div>
            <div class="advice-card__desc">会话提炼入库后想要触发的动作</div>
          </div>
          <i
            class="advice-card__arrow icon-arrow-up-s-line t-iconfont"
            :class="{ 'is-collapsed': !cardExpanded }"
          ></i>
        </div>
        <div v-show="cardExpanded" class="advice-card__body">
          <div class="advice-card__item">
            <div class="advice-card__item-head">
              <div class="advice-card__item-title">关联访客计划</div>
              <button
                class="advice-card__switch"
                :class="{ 'is-on': actionConfig.linkCommunicatePlanEnable === 1 }"
                type="button"
                @click.stop="handleToggle('linkCommunicatePlanEnable')"
              >
                <span class="advice-card__switch-dot"></span>
              </button>
            </div>
            <div class="advice-card__item-desc">开启后，允许成员将本次跟进记录关联访客计划</div>
          </div>
          <div class="advice-card__item advice-card__item--last">
            <div class="advice-card__item-head">
              <div class="advice-card__item-title">AI 推荐跟进任务</div>
              <button
                class="advice-card__switch"
                :class="{ 'is-on': actionConfig.recommendTaskEnable === 1 }"
                type="button"
                @click.stop="handleToggle('recommendTaskEnable')"
              >
                <span class="advice-card__switch-dot"></span>
              </button>
            </div>
            <div class="advice-card__item-desc">
              开启后，AI 将根据跟进内容生成推荐任务，运行将消耗一定算力。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="preview-panel">
        <!-- 头部 -->
        <div class="preview-panel__header">
          <span class="preview-panel__header-title">预览</span>
          <span class="preview-panel__header-tip">预览为示例数据，仅供参考</span>
        </div>
        <template
          v-if="
            actionConfig.linkCommunicatePlanEnable === 0 && actionConfig.recommendTaskEnable === 0
          "
        >
          <div class="preview-panel__body">
            <list-empty title="左侧开启配置可以在这里预览效果哦" />
          </div>
        </template>
        <template v-else>
          <div class="preview-panel__body">
            <!-- 文案行 -->
            <div class="preview-panel__intro">
              <div class="preview-panel__intro-avatar">
                <img alt="销小帮" class="preview-panel__intro-img" src="@/assets/logo.svg" />
              </div>
              <span class="preview-panel__intro-text">
                根据本次会话分析已为你推荐可关联访客计划与下一步行动建议
              </span>
            </div>
            <!-- 消息卡片 -->
            <div class="preview-panel__card">
              <!-- 关联访客计划：开关开启时显示 -->
              <div v-show="actionConfig.linkCommunicatePlanEnable === 1" class="preview-section">
                <div class="preview-section__title">关联访客计划</div>
                <div class="preview-section__content">
                  <div class="preview-section__ai-tip">
                    <i class="icon-sparkling-2-fill preview-section__ai-icon t-iconfont"></i>
                    <span class="preview-section__ai-text">助手为你推荐可关联访客计划</span>
                  </div>
                  <!-- 访客计划卡片 -->
                  <div class="preview-visit-card">
                    <div class="preview-visit-card__info">
                      <div class="preview-visit-card__name">明天拜访客户了解一下购买意愿度</div>
                      <div class="preview-visit-card__desc">
                        X总您好，我是贵司销帮帮客成经理，想跟您确认下贵司系统数据是否还需要保留备份。前面一直没有联系上您，您的系统数据...
                      </div>
                    </div>
                    <div class="preview-visit-card__fields">
                      <div class="preview-visit-card__field">
                        <span class="preview-visit-card__field-label">执行时间</span>
                        <span class="preview-visit-card__field-value">05 月 30 日 11:00</span>
                      </div>
                      <div class="preview-visit-card__field">
                        <span class="preview-visit-card__field-label">拜访目的</span>
                        <span class="preview-visit-card__field-value">建立客情</span>
                      </div>
                    </div>
                  </div>
                  <!-- 操作按钮 -->
                  <div class="preview-actions">
                    <button
                      class="preview-actions__btn preview-actions__btn--default"
                      type="button"
                    >
                      关联其他
                    </button>
                    <button
                      class="preview-actions__btn preview-actions__btn--primary"
                      type="button"
                    >
                      确定关联
                    </button>
                  </div>
                </div>
              </div>
              <!-- 虚线分隔：两个都开启时才显示 -->
              <div
                v-show="
                  actionConfig.linkCommunicatePlanEnable === 1 &&
                  actionConfig.recommendTaskEnable === 1
                "
                class="preview-divider"
              ></div>
              <!-- AI 推荐任务：开关开启时显示 -->
              <div v-show="actionConfig.recommendTaskEnable === 1" class="preview-section">
                <div class="preview-section__title">AI 推荐任务</div>
                <div class="preview-section__content">
                  <!-- 任务卡片 -->
                  <div class="preview-task-card">
                    <div class="preview-task-card__header">
                      <div class="preview-task-card__name">和张总预约下周三方案演示</div>
                      <div class="preview-task-card__time">
                        <i
                          class="icon-calendar2-ai-line preview-task-card__time-icon t-iconfont"
                        ></i>
                        <span class="preview-task-card__time-label">推荐拜访时间：</span>
                        <span class="preview-task-card__time-value">2025-12-10 14:30</span>
                      </div>
                    </div>
                    <!-- AI 分析理由 -->
                    <div class="preview-task-card__reason">
                      客户在最近 3 次沟通中提问频率显著增加（平均每次 8 个技术问题），
                      且在周五下班前主动追问方案修订进度，展现出较强的紧迫感。
                    </div>
                    <!-- 操作按钮 -->
                    <div class="preview-actions">
                      <button
                        class="preview-actions__btn preview-actions__btn--default"
                        type="button"
                      >
                        <i class="icon-eye-off-line t-iconfont"></i>
                        忽略
                      </button>
                      <button
                        class="preview-actions__btn preview-actions__btn--primary"
                        type="button"
                      >
                        <i class="icon-briefcase-ai-line t-iconfont"></i>
                        加入访客计划
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getMeetingAssistantConfig, updateMeetingAssistantConfig } from '@/api'
import ListEmpty from '@/pages/ai-board/components/list-empty.vue'
import { useSystemSetStore } from '@/store/systemSet'

const ACTION_STRATEGY_TYPE = 1

const defaultActionConfig = {
  linkCommunicatePlanEnable: 0,
  refiningCommunicatePlanEnable: 0,
  recommendTaskEnable: 0
}

const configLoading = ref(false)
const cardExpanded = ref(true)
const configId = ref(null)
const actionConfig = ref({ ...defaultActionConfig })
const systemStore = useSystemSetStore()

const syncSystemStore = () => {
  systemStore.setLinkCommunicatePlanEnable(!!actionConfig.value.linkCommunicatePlanEnable)
  systemStore.setRefiningCommunicatePlanEnable(!!actionConfig.value.refiningCommunicatePlanEnable)
  systemStore.setRecommendTaskEnable(!!actionConfig.value.recommendTaskEnable)
}

const getConfigInfo = async () => {
  try {
    configLoading.value = true
    const { result } = await getMeetingAssistantConfig({
      type: ACTION_STRATEGY_TYPE
    })

    if (result?.data) {
      configId.value = result.data.id
      actionConfig.value = {
        ...defaultActionConfig,
        ...JSON.parse(result.data.config || '{}')
      }
    } else {
      configId.value = null
      actionConfig.value = { ...defaultActionConfig }
    }
    syncSystemStore()
  } catch (error) {
    console.error('获取行动策略配置失败', error)
  } finally {
    configLoading.value = false
  }
}

const updateActionConfig = async () => {
  try {
    configLoading.value = true
    await updateMeetingAssistantConfig({
      id: configId.value,
      type: ACTION_STRATEGY_TYPE,
      config: JSON.stringify({
        linkCommunicatePlanEnable: actionConfig.value.linkCommunicatePlanEnable,
        refiningCommunicatePlanEnable: actionConfig.value.refiningCommunicatePlanEnable,
        recommendTaskEnable: actionConfig.value.recommendTaskEnable
      })
    })
  } catch (error) {
    console.error('更新行动策略配置失败', error)
  } finally {
    await getConfigInfo()
  }
}

const handleToggle = async (field) => {
  actionConfig.value[field] = actionConfig.value[field] === 1 ? 0 : 1
  syncSystemStore()
  await updateActionConfig()
}

onMounted(() => {
  getConfigInfo()
})
</script>

<style lang="scss" scoped>
$advice-card-bg: #ffffff; // 填充/纯白
$advice-card-border: #e5e6eb; // 线条/Line-2 一般线条
$advice-card-title: #323233; // 文字/Text-4 强调正文标题
$advice-card-desc: #969799; // 文字/Text-2 次要信息
$advice-card-switch-on: #7a52f4; // 拓展色/紫罗兰/Violets-6
$advice-card-shadow: 0 6px 16px rgba(0, 0, 0, 0.08); // 三级投影/高

.advice {
  height: 100%;
  min-height: 0;
  display: flex;
  justify-content: center;

  .left {
    width: 588px;
    box-sizing: border-box;
  }

  .right {
    width: 520px;
    height: 100%;
    min-height: 0;
    margin-left: 12px;
  }
}

.advice-card {
  overflow: hidden;
  background: $advice-card-bg;
  border: 1px solid $advice-card-border;
  border-radius: 12px;
  box-shadow: $advice-card-shadow;

  &__header {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid $advice-card-border;
    box-sizing: border-box;
    cursor: pointer;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border-radius: 8px;

    .t-iconfont {
      font-size: 20px;
      color: $advice-card-title;
    }
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $advice-card-title;
  }

  &__desc {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    color: $advice-card-desc;
  }

  &__arrow {
    margin-left: 12px;
    font-size: 24px;
    color: $advice-card-desc;
    transition: transform 0.2s ease;

    &.is-collapsed {
      transform: rotate(180deg);
    }
  }

  &__body {
    padding: 16px;
    box-sizing: border-box;
  }

  &__item {
    &--last {
      margin-top: 16px;
    }
  }

  &__item-head {
    display: flex;
    align-items: center;
  }

  &__item-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $advice-card-title;
  }

  &__item-desc {
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    color: $advice-card-desc;
  }

  &__switch {
    position: relative;
    width: 30px;
    height: 16px;
    margin-left: 12px;
    padding: 0;
    background: $advice-card-desc;
    border: 0;
    border-radius: 100px;
    cursor: pointer;
    transition: background 0.2s ease;

    &.is-on {
      background: $advice-card-switch-on;

      .advice-card__switch-dot {
        left: 16px;
      }
    }
  }

  &__switch-dot {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    background: $advice-card-bg;
    border-radius: 50%;
    transition: left 0.2s ease;
  }
}

// ── 预览面板 ──────────────────────────────────────────────
$preview-bg: #f2f3f5; // 填充/Fill-2 一般 常规 白底悬浮
$preview-card-bg: #ffffff; // 填充/纯白
$preview-border: #e5e6eb; // 线条/Line-2 一般线条
$preview-border-light: #f2f3f5; // 线条/Line-1 浅线条
$preview-title: #323233; // 文字/Text-4 强调正文标题
$preview-sub-title: #646566; // 文字/Text-3 次强调正文标题
$preview-desc: #969799; // 文字/Text-2 次要信息
$preview-purple: #7a52f4; // 拓展色/紫罗兰/Violets-6
$preview-purple-light: #f5e8ff; // 拓展色/紫罗兰/Violets-1
$preview-fill-light: #f7f8fa; // 填充/Fill-1 浅色 禁用背景
$preview-ai-bg: linear-gradient(282deg, #eef2ff 1%, #f5f3ff 100%); // 渐变背景
$preview-shadow: 0 6px 16px rgba(0, 0, 0, 0.08); // 三级投影/高

.preview-panel {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid $preview-border;
  border-radius: 12px;
  box-shadow: $preview-shadow;

  &__header {
    display: flex;
    align-items: center;
    padding: 12px;
    background: $preview-bg;
    border-bottom: 1px solid $preview-border;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  &__header-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $preview-title;
  }

  &__header-tip {
    margin-left: 12px;
    font-size: 12px;
    line-height: 16px;
    color: $preview-desc;
  }

  &__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 16px;
    overflow-y: auto;
    background: $preview-bg;
    box-sizing: border-box;
  }

  &__intro {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__intro-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 8px;
  }

  &__intro-img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  &__intro-text {
    font-size: 14px;
    line-height: 20px;
    color: $preview-desc;
  }

  &__card {
    padding: 12px;
    background: $preview-card-bg;
    border-radius: 12px;
    box-sizing: border-box;
    width: 400px;
  }
}

.preview-section {
  &__title {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $preview-title;
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__ai-tip {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  &__ai-icon {
    margin-right: 8px;
    font-size: 16px;
    background: linear-gradient(314deg, #1574ff 2%, #5952ff 51%, #a969fe 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__ai-text {
    font-size: 14px;
    line-height: 20px;
    color: $preview-title;
  }
}

.preview-visit-card {
  padding: 12px;
  background: $preview-card-bg;
  border: 1px solid $preview-border;
  border-radius: 12px;
  box-sizing: border-box;
  margin-bottom: 12px;

  &__info {
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $preview-title;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 2px;
  }

  &__desc {
    font-size: 14px;
    line-height: 20px;
    color: $preview-desc;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__fields {
    display: flex;
    flex-direction: column;
  }

  &__field {
    display: flex;
    align-items: center;
    margin-top: 4px;

    &:first-child {
      margin-top: 0;
    }
  }

  &__field-label {
    width: 56px;
    flex-shrink: 0;
    font-size: 14px;
    line-height: 20px;
    color: $preview-desc;
    margin-right: 12px;
  }

  &__field-value {
    flex: 1;
    font-size: 14px;
    line-height: 20px;
    color: $preview-title;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.preview-task-card {
  padding: 12px;
  background: $preview-fill-light;
  border: 1px solid $preview-border-light;
  border-radius: 12px;
  box-sizing: border-box;

  &__header {
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
  }

  &__name {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: $preview-title;
    margin-bottom: 4px;
  }

  &__time {
    display: flex;
    align-items: center;
  }

  &__time-icon {
    font-size: 12px;
    color: $preview-desc;
    margin-right: 4px;
  }

  &__time-label {
    font-size: 12px;
    line-height: 16px;
    color: $preview-desc;
  }

  &__time-value {
    font-size: 12px;
    line-height: 16px;
    color: $preview-title;
  }

  &__reason {
    padding: 12px;
    background: $preview-ai-bg;
    border: 1px solid $preview-purple-light;
    border-radius: 12px;
    font-size: 13px;
    line-height: 18px;
    color: $preview-title;
    margin-bottom: 12px;
    box-sizing: border-box;
  }
}

.preview-divider {
  height: 1px;
  margin: 16px 0;
  border-top: 1px dashed $preview-border-light;
}

.preview-actions {
  display: flex;
  align-items: center;

  &__btn {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 34px;
    padding: 8px 12px;
    font-size: 13px;
    line-height: 18px;
    border-radius: 64px;
    cursor: pointer;
    box-sizing: border-box;
    background: transparent;

    .t-iconfont {
      margin-right: 4px;
      font-size: 14px;
    }

    &--default {
      border: 1px solid #e5e6eb;
      color: $preview-sub-title;
      margin-right: 12px;
    }

    &--primary {
      border: 1px solid $preview-purple;
      color: $preview-purple;
    }
  }
}
</style>
